import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import MuiDialogTitle from "@mui/material/DialogTitle";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@mui/material";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { MachineStatusStaticRow } from "../MachineStatusStaticRow";

export const HistoryMachineStatusDialog = ({
  caseId,
  onHandleOpenInNewTab,
  openDialog,
  onHideDialog,
  history
}) => {
  return (
    <Dialog maxWidth="lg" open={openDialog} aria-label="RTS Change Log">
      <MuiDialogTitle>
        <Typography>RTS Change Log</Typography>
      </MuiDialogTitle>

      <DialogContent>
        <TableScrollWrapper>
          <MachineTable stickyHeader aria-label="Machine status table">
            <TableHead>
              <TableRow>
                <TableClearCell size="small">Status</TableClearCell>
                <TableClearCell size="small">Date Set</TableClearCell>
                <TableClearCell size="small">Expected RTS</TableClearCell>
                <TableClearCell size="small">Updated</TableClearCell>
                <TableClearCell size="small">Updated By</TableClearCell>
                <TableClearCell size="small"></TableClearCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {history.map((machineStatus, index) => {
                return (
                  <MachineStatusStaticRow
                    key={`machine_status_row_${index}`}
                    caseId={caseId}
                    machineStatus={machineStatus}
                    onHandleOpenInNewTab={onHandleOpenInNewTab}
                    history={[machineStatus]}
                    userInfo={true}
                  />
                );
              })}
            </TableBody>
          </MachineTable>
        </TableScrollWrapper>
      </DialogContent>

      <DialogActions>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => onHideDialog(false)}
          data-qa="CP-Button-Cancel-Delete"
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

HistoryMachineStatusDialog.propTypes = {
  caseId: PropTypes.number,
  onHandleOpenInNewTab: PropTypes.func,
  openDialog: PropTypes.bool,
  onHideDialog: PropTypes.func,
  history: PropTypes.array
};

const TableScrollWrapper = styled("div")`
  width: 100%;
  overflow-x: auto;
`;

const MachineTable = styled(Table)`
  border: none;
`;

const TableClearCell = styled(TableCell)`
  border-bottom: none;
  color: #616161;
`;
